var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcPodcastPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 91 91",
    style: {
      enableBackground: "new 0 0 91 91"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M45.5,0C20.4,0,0,20.4,0,45.5s20.4,45.5,45.5,45.5s45.5-20.4,45.5-45.5S70.6,0,45.5,0z M45.5,88.9C21.5,88.9,2,69.4,2,45.5 S21.5,2,45.5,2s43.5,19.5,43.5,43.5S69.4,88.9,45.5,88.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1,44.5L34,26.4c-0.7-0.4-1.6,0.1-1.6,0.9v36.3c0,0.8,0.9,1.3,1.6,0.9l31-18.1C65.8,46,65.8,45,65.1,44.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPodcastPlay);
export default __webpack_public_path__ + "static/media/ic_podcast_play.ed851a280a7e01043f661cca3f3e34e8.svg";
export { ForwardRef as ReactComponent };